import type { SelectedStep } from '~/server/logic/prisma/step-select';
import type { useLiveStateManager } from '../useLiveStateManager';
import { isOperationOptimistic } from './optimistic-handles';

export const updateLiveStateOnStepRemoval = ({
  recorderState,
  updateLiveState,
  steps,
}: {
  recorderState: { stepId: string; stepOrder: number };
  updateLiveState: ReturnType<typeof useLiveStateManager>['updateLiveState'];
  steps: SelectedStep[];
}) => {
  const nextStep = steps.find((step) => step.stepOrder > recorderState?.stepOrder);
  const lastStep = steps.at(-1);
  updateLiveState((prev) => ({
    ...prev,
    recorderCursor:
      // First try to set the cursor at the next step
      nextStep ?
        {
          stepId: nextStep.id,
          stepOrder: nextStep.stepOrder,
          // As we don't set an operation here (operation = undefined), it will use the first recorder cursor place
          // at the very top of the step
        }
        // Fallback: If no next step, choose the last step (implies we just deleted the last step)
      : lastStep ?
        {
          stepId: lastStep.id,
          stepOrder: lastStep.stepOrder,
          operation: lastStep.operations
            .filter((op) => !isOperationOptimistic(op.id))
            .map((op) => ({ id: op.id, order: op.order }))
            .at(-1),
        }
      : undefined,
  }));
};
